import * as React from 'react';
import styled from 'styled-components';
import { useTreeContext } from './Context';
import { Node } from './Node';

export interface IGroupProps {
    parentId: string;
}

export const Group = ({ parentId }: IGroupProps) => {
    const { data } = useTreeContext();

    if (data && data.length) {
        const level = data.filter((e) => e.parentId === parentId);

        return (
            <List>
                {level.map((e) => {
                    const children = data.filter((c) => c.parentId === e.id);

                    return (
                        <li key={e.id}>
                            <Node children={data} hasChildren={children.length > 0} {...e} />
                        </li>
                    );
                })}
            </List>
        );
    }

    return null;
};

const List = styled.ul`
    list-style: none;
    padding: 0;
    margin: 0;

    ul {
        margin-left: 24px;
    }
`;
